/**
 * Séquence 3 — Apports théoriques · Code de la route (30 min)
 *
 * Officiel : signalisation (verticale + horizontale) et règles de circulation
 * (positionnement, ligne droite, virage, changement de direction, intersections,
 * régimes de priorité).
 */
export const sequence3 = {
  officiel: {
    signalisation: {
      description: "L'élève doit connaître la signalisation verticale et horizontale, et comprendre son rôle.",
      familles: [
        { key: 'danger',       label: 'Panneaux de danger',        desc: 'Triangulaires, bord rouge. Avertissent d’un danger à venir.' },
        { key: 'interdiction', label: 'Panneaux d’interdiction',   desc: 'Ronds, bord rouge. Interdisent une manoeuvre ou l’accès.' },
        { key: 'obligation',   label: 'Panneaux d’obligation',     desc: 'Ronds, fond bleu. Imposent un comportement.' },
        { key: 'indication',   label: 'Panneaux d’indication',     desc: 'Carrés ou rectangulaires, fond bleu. Informent.' },
        { key: 'directionnels', label: 'Panneaux directionnels',   desc: 'Flèches, orientent les usagers.' },
        { key: 'horizontale',  label: 'Signalisation horizontale', desc: 'Lignes, flèches, marquages au sol.' },
      ],
    },
    regles: {
      description: 'Les règles de circulation à connaître en priorité :',
      items: [
        'Positionnement du véhicule sur la chaussée',
        'Règles en ligne droite',
        'Règles en virage',
        'Changement de direction (tourner à gauche, à droite)',
        'Franchissement des intersections',
        'Régimes de priorité : priorité à droite, cédez-le-passage, stop, feux',
      ],
    },
  },
  enrichi: {
    miniQuizz: [
      {
        situation: 'Tu arrives à une intersection sans panneau ni marquage.',
        question: 'Que fais-tu ?',
        options: [
          { txt: "Je passe car je vais tout droit",                bon: false },
          { txt: "Je m'arrête complètement pour observer",       bon: false },
          { txt: "Je ralentis et je cède le passage aux véhicules venant de ma droite", bon: true },
        ],
        explication: "C'est la règle par défaut : la priorité à droite s'applique dans toute intersection non signalisée.",
      },
      {
        situation: "Un panneau rond avec un fond bleu indique 30 km/h.",
        question: 'Que signifie-t-il ?',
        options: [
          { txt: "Vitesse maximale autorisée 30 km/h", bon: false },
          { txt: "Vitesse minimale obligatoire 30 km/h", bon: true },
          { txt: "Zone 30 recommandée", bon: false },
        ],
        explication: "Fond bleu = OBLIGATION. Ici, l'élève doit maintenir au minimum 30 km/h. Peu appliqué aux voiturettes limitées à 45 km/h.",
      },
      {
        situation: 'Une ligne blanche continue est tracée au milieu de la chaussée.',
        question: 'Peux-tu la franchir pour dépasser ?',
        options: [
          { txt: 'Oui, uniquement si la voie est libre',   bon: false },
          { txt: 'Non, jamais',                            bon: true },
          { txt: "Oui si je suis coincé derrière un lent", bon: false },
        ],
        explication: 'La ligne continue interdit tout franchissement, même pour dépasser un véhicule lent.',
      },
    ],
    astucesVoiturette: [
      "En voiturette tu ne dépasses pas 45 km/h : la plupart des panneaux de vitesse maximum ne te concernent pas, mais les vitesses MINIMUM et les interdictions s'appliquent à toi.",
      "Panneau C107 (voie autoroute) et C108 (voie pour automobiles) = INTERDIT aux voiturettes.",
      "Sur une voie étroite, positionne-toi à droite mais pas collé au bas-côté : garde 50 cm de marge.",
    ],
  },
};

export default sequence3;
